export function criarIndicadorAindaNaoIniciou (estados, totalEmpregados, calcularPorcentagem) {
  const total = estados.emAtraso.total + estados.aEntrarEmBreve.total + estados.antesDeTrabalhar.total
  return { total, porcentagem: calcularPorcentagem(total, totalEmpregados) }
}
